import React from "react";
import "../../../css/View/ActionIcon.css";

const ActionIcon = ({ icon, label, active, disabled, onClick }) => {
  return (
    <div
      className={`trip-details-button-container ${active ? "active" : ""} ${
        disabled ? "disabled" : ""
      }`}
      onClick={() => !disabled && onClick()}
    >
      <div className="trip-details-button">{icon}</div>
      <span className="trip-details-button-label">{label}</span>
    </div>
  );
};

export default ActionIcon;
